import { isThreadListMember } from '../thread-list-member/isThreadListMember';
import { getConversationId } from '../thread-list-member/threadListMemberGetters';
import { getViewMemberId } from './getViewMemberId';
export const isInboxViewMember = viewMember => {
  return !isThreadListMember(viewMember) && viewMember['@type'] === 'INBOX_VIEW_MEMBER';
};
export const isInboxThreadListMember = viewMember => {
  return isThreadListMember(viewMember) && +getViewMemberId(viewMember) !== getConversationId(viewMember);
};